// 导出该模块state、actions、mutations
import { extend } from 'sk-ui/lib/utils/util.js'

import peripheral from '../../peripheralMng/metaData/peripheral'
import actions from '../actions'
const peripheralCopy = extend(true, {}, peripheral)
peripheralCopy.toolbar.items = []
delete peripheralCopy.view.menus[1]
export default {
  state: peripheralCopy,
  actions
}
